import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { logEventV2 } from '@gelato-api-ui/core/analytics/helpers/trackEvent';
import { EStore } from '@gelato-api-ui/core/e-commerce/e-store';
import { GelatoPublisherEventName } from '@api-ui-app/src/app/e-commerce-product-expansion/types/gelato-publisher-event-name.enum';

@Component({
  selector: 'gd-header-create-menu-stateless',
  templateUrl: './header-create-menu-stateless.component.html',
  styleUrls: ['./header-create-menu-stateless.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderCreateMenuStatelessComponent {
  @Input() isMobile: boolean;
  @Input() storesList: EStore[];

  @Output() addNewProduct = new EventEmitter<void>();
  @Output() designUpload = new EventEmitter<void>();
  @Output() storeConnect = new EventEmitter<void>();

  GelatoPublisherEventName = GelatoPublisherEventName;

  onAddNewProduct() {
    logEventV2('Header Add New product Clicked');
    this.addNewProduct.emit();
  }

  connectStore() {
    this.storeConnect.emit();
  }

  uploadDesign() {
    this.designUpload.emit();
  }
}
